var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal",
      class: _vm.additionalClasses,
      style: _vm.showStyle,
      attrs: { tabindex: "-1", role: "dialog" },
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.close.apply(null, arguments)
        }
      }
    },
    [
      _c("transition", { attrs: { name: "slide-up" } }, [
        _vm.is_open
          ? _c(
              "div",
              { staticClass: "modal-dialog", attrs: { role: "document" } },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c(
                    "div",
                    { staticClass: "modal-header" },
                    [
                      _vm._t(
                        "header",
                        function() {
                          return [
                            _c(
                              "h5",
                              { staticClass: "modal-title" },
                              [
                                _vm.icon
                                  ? _c("masked-image", {
                                      staticClass: "modal-title-icon",
                                      attrs: { src: "/img/icons/" + _vm.icon }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: { innerHTML: _vm._s(_vm.title) }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("close-modal", { on: { click: _vm.forceClose } })
                          ]
                        },
                        { data: _vm.extra_data, close: _vm.close }
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-body" },
                    [_vm._t("body", null, { data: _vm.extra_data })],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-footer" },
                    [_vm._t("footer")],
                    2
                  )
                ])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "modal-backdrop fade",
        class: { show: _vm.is_open },
        on: { click: _vm.forceClose }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }